import React from 'react';
import ServiceCard from '../components/ServiceCard';
import CtaBand     from '../components/CtaBand';
import { SERVICES } from '../constants/data';
import styles from './Services.module.css';

export default function Services() {
  return (
    <main className="page-wrapper">
      {/* Page header */}
      <div className="page-header">
        <div className={styles.headerInner}>
          <span className="eyebrow">Neler Yapıyoruz</span>
          <h1>Hizmetlerimiz</h1>
          <p className={styles.headerSub}>
            Asansör montajından periyodik bakıma, modernizasyondan teknik muayeneye
            kadar her aşamada yanınızdayız.
          </p>
        </div>
      </div>

      {/* Services grid – full detail */}
      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.grid}>
            {SERVICES.map(s => (
              <ServiceCard
                key={s.id}
                icon={s.icon}
                title={s.title}
                desc={s.desc}
                features={s.features}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Process steps */}
      <section className={styles.processSection}>
        <div className={styles.container}>
          <div className="section-title">
            <span className="eyebrow">Nasıl Çalışırız</span>
            <h2>Proje Süreci</h2>
            <p>Tekliften teslimata, şeffaf ve planlı bir süreç yürütüyoruz.</p>
          </div>
          <div className={styles.steps}>
            {[
              { n: '01', title: 'Keşif & Teklif',     desc: 'Sahaya çıkarak ölçüm ve fizibilite değerlendirmesi yapıyoruz. 24 saat içinde detaylı teklifinizi sunuyoruz.' },
              { n: '02', title: 'Proje & Onay',        desc: 'Teknik çizimler ve ruhsat belgelerini hazırlayıp ilgili kurumlardan onay alıyoruz.' },
              { n: '03', title: 'Montaj & Test',        desc: 'Sertifikalı ekibimiz montajı tamamlar, tüm güvenlik testlerini gerçekleştirir.' },
              { n: '04', title: 'Devir & Bakım',        desc: 'Belgeli devir teslim yapılır, periyodik bakım sözleşmesi imzalanır, 7/24 destek başlar.' },
            ].map(step => (
              <div key={step.n} className={styles.step}>
                <div className={styles.stepNum}>{step.n}</div>
                <div>
                  <div className={styles.stepTitle}>{step.title}</div>
                  <div className={styles.stepDesc}>{step.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </main>
  );
}
